import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../config';
import type { IpAllowlistEntry, SecuritySettingsConfig } from '../../../../types/security';

/**
 * テナントのセキュリティ設定（companies/{companyId}/security_settings/config）を取得する（#2982-2985）。
 * Firestore ルールで read は同社 companyAdmin または運営スタッフのみ許可。未設定時は null。
 */
export const getSecuritySettingsConfig = async (
  companyId: string,
): Promise<SecuritySettingsConfig | null> => {
  const ref = doc(db, 'companies', companyId, 'security_settings', 'config');
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  const data = snap.data();
  const ipAllowlist: IpAllowlistEntry[] = Array.isArray(data.ip_allowlist)
    ? (data.ip_allowlist as IpAllowlistEntry[])
    : [];
  return {
    ip_allowlist: ipAllowlist,
    ip_restriction_disabled: data.ip_restriction_disabled === true,
    saml: data.saml ?? null,
    saml_mode_bypass: data.saml_mode_bypass === true,
    mfa_required: data.mfa_required === true,
    updated_by: (data.updated_by as string) ?? '',
    updated_at: data.updated_at?.toDate?.() ?? new Date(0),
  };
};
